import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../minor-components/Loader";
import { getDelivery } from "../../redux/Actions/DeliveryAction";
import ShopLocationsMap from "./ShopLocationsMap";
import { axiosInstance } from "../../constants/axiosInstance";
import { Footer } from "./Footer";
import 'leaflet/dist/leaflet.css';

export const Delivery = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.ProgressBarReducer);
  const { data, headings } = useSelector((state) => state.deliveryReducer);
  const [shops, setShops] = useState([]);

  useEffect(() => {
    dispatch(getDelivery());
    getShopLocations();
  }, [dispatch]);

  const getShopLocations = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/admin/getradius");
      if (response.data?.success) {
        setShops(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
    }
  };

  // Add this to debug what's rendering
  console.log("Rendering Delivery component:", { loading, shops, data, headings });

  if (loading) {
    console.log("Showing loader");
    return <Loader />;
  }

  return (
    <div className="min-h-screen bg-white"> {/* Added bg-white for visibility */}
      <div className="py-20 text-center">
        
        
      <div className="text-3xl lg:text-4xl font-bold leading-9 text-gray-800 pb-4"
  dangerouslySetInnerHTML={{ __html: headings || 'Delivery Zone' }}
/>

        <div className="w-full h-[60vh] my-4 border-2 border-red-500"> {/* Added visible border */}
          {shops.length > 0 ? (
            <ShopLocationsMap shops={shops} />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-100">
              <p className="text-black">Loading shop locations...</p>
            </div>
          )}
        </div>
        {data && (
  <div 
    className="lg:px-28 px-5 text-left text-black"
    dangerouslySetInnerHTML={{ __html: data }}
  />

        )}
      </div>
      <Footer />
    </div>
  );
};